<template>
	<div>
		<!-- 四列 -->
		<div :style="shu.yangshi" class="zidingyi_fuwu1 box_show" v-show="a">
			<div class="zidingyi_fuwu_top ziti12px">常用服务</div>
			<div class="zidingyi_fuwulie">
				<div class="zidingyi_fuwu_lie" v-for="l in shu.shu">
					<img :src="l.tu" alt="" class="zidingyi_fuwu_lie_img">
					<div class="ziti12px zidingyi_fuwu_lie_name">{{l.ming}}</div>
				</div>
			</div>
		</div>
		<!-- 一列 -->
		<div :style="shu.yangshi" class="zidingyi_fuwu1 box_show" v-show="b">
				<div class="zidingyi_fuwu2_lie" v-for="l in shu.shu">
					<div class="zidingyi_fuwu2_left">
						<img :src="l.tu" alt="" class="zidingyi_fuwu_lie_img">
						<div class="ziti12px zidingyi_fuwu2_lie_name">{{l.ming}}</div>
					</div>
					<span>></span>
				</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'anniu',
		data() {
			return {
				fuwulie: [{
						ming: '收货地址',
						tu: 'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/cUq3NSEfoz7Rnc4Qis1cRiIfFSRNE7.png'
					},
					{
						ming: '邀请好友',
						tu: 'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/oe4422sirBR9kmy87k8a2Azy4Z9b9r.png'
					},
					{
						ming: '优惠券',
						tu: 'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/cUq3NSEfoz7Rnc4Qis1cRiIfFSRNE7.png'
					},
					{
						ming: '我的团队',
						tu: 'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/HH0P3669Hlp93telpf31bEPfP00pH0.png'
					},
					{
						ming: '我的收藏',
						tu: 'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/NRZdvxffvS5u0iQ8Qs5TR8RF58vZxr.png'
					},
					{
						ming: '投票榜单',
						tu: 'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/O9QSi0iK99K0reZzZuh7u075O7oOw9.png'
					},
					{
						ming: '分享',
						tu: 'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/fMQT84qw8TfzSp2XnMa48aAyasqN8w.png'
					},
					{
						ming: '问题反馈',
						tu: 'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/hCvcebwodxiw8G2079H9OEbC077ixb.png'
					},
				],
				a: 0,
				b:1
			}
		},
		props: {
			shu: {
				type: Object,
				default () {
					return {
						wenzi: '输入文字',
						yangshi: {}
					}
				}
			}
		},
		created() {
			if (!this.shu.shu) {
				this.$set(this.shu, 'shu', this.fuwulie)
			}
		}

	}
</script>
